export const ADMISSION_PRIORITIES = ['elective', 'urgent', 'emergency'];
export const ADMISSION_SOURCES = ['opd', 'er', 'direct', 'transfer_in'];
export function admissionPriorityFromSource(source) {
    if (source === 'er')
        return 'emergency';
    if (source === 'transfer_in')
        return 'urgent';
    return 'elective';
}
export function isAdmissionPriority(value) {
    return typeof value === 'string' && ADMISSION_PRIORITIES.includes(value);
}
//# sourceMappingURL=admission-priority.js.map